import { createStore } from '@store/index';
import Cookies from 'js-cookie';
import type { Store } from '@store/store/store';
import type { StoreOptions } from '@store/types/storeOptions';
import type { StoreValue } from '@store/types/storeValue';

export const wishlistStore: Store = createStore<StoreOptions>({
    name: 'wishlist',
    initialValue: [],
    type: Array
});

export const wishlistRetryStore = createStore<StoreOptions>({
    name: 'wishlistRetry',
    type: Object,
    initialValue: () => {
        try {
            const raw = Cookies.get('retrywishlist');
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : {};

            return typeof parsed === 'object' && parsed !== null ? parsed : {};
        } catch {
            return {};
        }
    },
    onSet(value: StoreValue): void {
        if (typeof value !== 'undefined' && value !== null) {
            Cookies.set('retrywishlist', JSON.stringify(value), { sameSite: 'Lax', expires: 1 });
        } else {
            Cookies.remove('retrywishlist');
        }
    }
});

export const wishlistRetryContext = createStore<StoreOptions>({
    name: 'wishlistRetryContext',
    type: String,
    initialValue: () => {
        const raw = Cookies.get('wishlistcontext');
        return typeof raw === 'string' ? raw : '';
    },
    onSet(value: StoreValue): void {
        if (typeof value === 'string' && value.length > 0) {
            Cookies.set('wishlistcontext', value, { sameSite: 'Lax', expires: 1 });
        } else {
            Cookies.remove('wishlistcontext');
        }
    }
});
